import { useEffect } from "react";

export function useDocumentTitle(title?: string, removeSuffix?: boolean) {
    useEffect(() => {
        if (title && title.length > 0) {
            document.title = `${title} ${!removeSuffix && `| Gitpod`}`;
        }
    }, [removeSuffix, title]);
}
